var map = {
	"./OpenRedeemRewards.png": 15641,
	"./TotalIncompleteMechanics.png": 42174,
	"./TotalIncompleteRetailers.png": 35704,
	"./TotalOpenContactForms.png": 6482,
	"./TotalOpenEnquiries.png": 93552,
	"./TotalRetailerVerifiedWithoutTarget.png": 63516,
	"./add.svg": 71480,
	"./addpoints.svg": 23125,
	"./bell.svg": 73516,
	"./checked.svg": 49406,
	"./chevron-down.svg": 79573,
	"./close-circle.svg": 49866,
	"./contactLog.svg": 88117,
	"./content.svg": 51362,
	"./dashboard.svg": 17461,
	"./delete.svg": 90930,
	"./downloadIcon.svg": 31080,
	"./edit.svg": 975,
	"./enquiry.svg": 2018,
	"./eye.svg": 34426,
	"./feedback.svg": 9322,
	"./file-text.svg": 67671,
	"./filter.svg": 87985,
	"./kglogo.svg": 87724,
	"./logout.svg": 34277,
	"./manageAdmins.svg": 21298,
	"./next.svg": 72396,
	"./notification.svg": 30566,
	"./previous.svg": 40612,
	"./productCatalog.svg": 84477,
	"./qrCode.svg": 27705,
	"./qrImg.svg": 48271,
	"./redCircle.svg": 50148,
	"./refresh.png": 17220,
	"./report.svg": 97501,
	"./resources.svg": 64946,
	"./rewards.svg": 37685,
	"./search.svg": 64343,
	"./send.svg": 46385,
	"./star.svg": 40815,
	"./tick.svg": 16920,
	"./totalFeedback.svg": 37818,
	"./totalProducts.svg": 84547,
	"./totalQR.svg": 57234,
	"./totalUsers.svg": 97733,
	"./upload.png": 24154,
	"./uploadIcon.svg": 68179,
	"./uploadSecondaryIcon.svg": 11637,
	"./users.svg": 73557,
	"./warning.svg": 42865,
	"./x-circle.png": 7656,
	"./x-circle.svg": 5046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;